var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hc-dieuxe-update-common-dialog',{attrs:{"isOpen":_vm.isOpen,"id":_vm.id,"action":_vm.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.PHE_DUYET},on:{"dialogClosed":function($event){return _vm.$emit('dialogClosed')},"closeDialog":function($event){return _vm.$emit('closeDialog')},"submit":_vm.submit}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1e85a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/dieuxe/hc-dieuxe-approve-dialog.vue
// module id = f2C0
// module chunks = 89